import React from 'react';
import { Trans, useTranslation } from '@wix/cli-i18n';
import { Box, Text, Learn, Link, Rocket } from '@wix/cli-ui-kit';

export const BlockGenerationSuccessMessage = () => {
  const { t } = useTranslation();
  return (
    <Box
      borderColor="blue"
      borderStyle="round"
      flexDirection="column"
      paddingY={1}
      paddingX={3}
      gap={1}
      marginTop={1}
    >
      <Box marginTop={-2} marginLeft={0}>
        <Text skin="question" bold>
          {t('generate_command.blocks.success.title')}
        </Text>
      </Box>
      <Trans
        i18nKey="generate_command.blocks.success.info.title"
        components={[<Rocket />]}
      />
      <Box paddingLeft={3}>
        <Trans i18nKey="generate_command.blocks.success.info.steps" />
      </Box>

      <Trans
        i18nKey="generate_command.generation.learn_more"
        values={{ extensionType: 'blocks widgets' }}
        // https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/wix-cli/supported-extensions/site-extensions/blocks-site-widgets/add-a-blocks-site-widget-extension-in-the-cli
        components={[<Learn />, <Link url={'https://wix.to/HuMifhw'} />]}
      />
    </Box>
  );
};
